import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterModule } from '@angular/router';
import { BankingService } from '../../features/banking/services/banking.service';
import { MatIconModule } from '@angular/material/icon';
import { MaskCardNumberPipe } from '../../shared/pipes/mask-creditCard.pipe';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-banking',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    RouterModule,
    MatIconModule,
    MaskCardNumberPipe,
  ],
  templateUrl: './banking.component.html',
  styleUrl: './banking.component.scss',
})
export class BankingComponent {
  loading: boolean = false;
  selectedOption = 'allAccounts';
  readonly dialog = inject(MatDialog);
  search: any;
  accounts: any;
  creditCards: any;
  netAmounts: any;
  showBalance: boolean = false;
  canListBanking$ = this.permissionService.hasPermission(
    ModuleIds.Banking,
    'List'
  );
  canCreateBanking$ = this.permissionService.hasPermission(
    ModuleIds.Banking,
    'Create'
  );
  canEditBanking$ = this.permissionService.hasPermission(
    ModuleIds.Banking,
    'Edit'
  );
  canDeleteBanking$ = this.permissionService.hasPermission(
    ModuleIds.Banking,
    'Delete'
  );

  toggleBalance() {
    this.showBalance = !this.showBalance;
    return this.showBalance;
  }

  constructor(
    private bankingService: BankingService,
    private router: Router,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.getAllBankAccounts();
    this.getAllCreditCards();
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  openDetailPage(id: any) {
    this.router.navigate([`banking/banking-details/${id}`]);
  }

  getAllBankAccounts() {
    this.loading = true;
    this.bankingService.listAllBankAccounts(this.search).subscribe({
      next: (accounts: any) => {
        this.loading = false;
        this.accounts = accounts;
      },
      error: (error) => {
        console.error(error, 'Error');
        this.loading = false;
      },
    });
  }

  getAllCreditCards() {
    this.loading = true;
    this.bankingService.listAllCreditCards(this.search).subscribe({
      next: (creditCards: any) => {
        this.loading = false;
        this.creditCards = creditCards;
      },
      error: (error) => {
        console.error(error, 'Error');
        this.loading = false;
      },
    });
  }

  goToAccountDetail(account: any, event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (targetElement.closest('button')) {
      return;
    }
    this.router.navigate([
      'banking/banking-details',
      account?.chartOfAccount?.id,
    ]);
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.search = input.value;
    console.log(this.search);
    this.getAllBankAccounts();
    this.getAllCreditCards();
  }

  onEditBankAccount(id: any) {
    this.router.navigate([`/banking/edit-bank-account/${id}`], {
      queryParams: { type: 'bank' },
    });
  }

  onEditCreditCard(id: any) {
    this.router.navigate([`/banking/edit-credit-card/${id}`], {
      queryParams: { type: 'credit' },
    });
  }
}
